import { render } from "./WidgetCard.vue?vue&type=template&id=94fea492&scoped=true"
import script from "./WidgetCard.vue?vue&type=script&lang=js"
export * from "./WidgetCard.vue?vue&type=script&lang=js"

import "./WidgetCard.vue?vue&type=style&index=0&id=94fea492&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94fea492"]])

export default __exports__